import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import Check from 'mdi-react/CheckIcon';

import ModalWrapper from '../../../ModalWrapper';
import styles from '../../../Forms/Input/Input.module.scss';

type Props = {
  closeModal: () => void;
  value?: string;
};

const AcceptModal: React.FC<Props> = ({ closeModal }) => {
  const [values, setValues] = useState<string>('');
  const [errText, setErrText] = useState<string>('');

  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    if (value.length > 4) return;

    setValues(value);
    if (!value.length) {
      setErrText("Поле обов'язкове");
    } else if (!value.match(/^\d+$/)) {
      setErrText('Поле повинно містити тільки цифри');
    } else {
      setErrText('');
    }
  };

  return (
    <ModalWrapper show onHide={closeModal}>
      <div className="d-flex flex-column">
        <h6>Ввeдіть код з СМС-повідомлення:</h6>
        <Form.Control
          type="number"
          step="1"
          pattern="\d+"
          value={values}
          onChange={changeHandler}
          isInvalid={!!errText}
          className={styles.input}
        />
        {errText ? <Form.Control.Feedback type="invalid">{errText}</Form.Control.Feedback> : null}
        <div className="d-flex justify-content-center mt-3">
          <Button className="mr-4 px-5" variant="outline-secondary">
            Надіслати повторно
          </Button>
          <Button className="px-5" onClick={() => null} variant="outline-secondary">
            Підтвердити <Check className="ml-1 text-success" />
          </Button>
        </div>
      </div>
    </ModalWrapper>
  );
};

export default AcceptModal;
